import React from 'react'
import ReactDOM from 'react-dom/client'
import * as Sentry from '@sentry/react'
import App from './App.tsx'
import './config/firebase' // Firebase初期化を最初に実行
import 'bootstrap/dist/css/bootstrap.min.css'
import 'bootstrap-icons/font/bootstrap-icons.css'
import './assets/scss/app.scss'

const isProductionMode = import.meta.env.MODE === 'production'
const sentryDsn = isProductionMode
  ? import.meta.env.VITE_SENTRY_DSN_PROD
  : import.meta.env.VITE_SENTRY_DSN_DEV

if (sentryDsn) {
  Sentry.init({
    dsn: sentryDsn,
    environment: import.meta.env.MODE,
    integrations: [Sentry.browserTracingIntegration()],
    tracesSampleRate: isProductionMode ? 0.1 : 0.0,
    // Session Replay(画面録画)を明示的に無効化
    replaysSessionSampleRate: 0.0,
    replaysOnErrorSampleRate: 0.0,
    // ユーザーの個人情報を自動送信しない
    sendDefaultPii: false,
    // Firebase関連のfetch breadcrumbはノイズになりやすいため除外
    beforeBreadcrumb(breadcrumb) {
      if (breadcrumb.category === 'fetch' && breadcrumb.data?.url?.includes('firestore.googleapis.com')) {
        return null
      }
      return breadcrumb
    },
  })
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
)

